import { useQuery } from "@tanstack/react-query";
import { MailX, Flame } from "lucide-react";
import api from "@/lib/api";

export function EmailStatusBadge({ email, className = "" }) {
  const e = (email || "").trim().toLowerCase();
  const { data } = useQuery({
    queryKey: ["email-status", e],
    queryFn: async () => (await api.get(`/marketing/email-status/${encodeURIComponent(e)}`)).data,
    enabled: !!e && e.includes("@"),
    staleTime: 60000,
    retry: false,
  });
  if (!data || (!data.opted_out && !data.engagement)) return null;
  const eng = data.engagement;
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="email-status-badge">
      {data.opted_out && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-50 text-red-700 text-[11px] font-semibold border border-red-100"
          title={`Opted out (${data.reason || "manual"})${data.optout_at ? ` on ${data.optout_at.slice(0, 10)}` : ""}${data.scope === "all" ? " — email bounced, do not email at all" : " — marketing emails only; transactional (quotes) still allowed"}`}
          data-testid="email-optout-badge">
          <MailX className="h-3 w-3" /> Do not email · {data.reason || "opted out"}{data.optout_at ? ` · ${data.optout_at.slice(0, 10)}` : ""}
        </span>
      )}
      {eng && (eng.opens > 0 || eng.clicks > 0) && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-[11px] font-semibold border border-emerald-100"
          title={`${eng.last_campaign ? `Last campaign: ${eng.last_campaign}. ` : ""}${(eng.links || []).length ? `Clicked: ${(eng.links || []).slice(0, 3).join(", ")}` : ""}`}
          data-testid="email-engagement-badge">
          <Flame className="h-3 w-3" /> Opened {eng.opens || 0}×{eng.clicks ? ` · Clicked ${eng.clicks}×` : ""}{eng.clicks > 0 ? " · hot" : ""}
        </span>
      )}
    </div>
  );
}
